import { render, staticRenderFns } from "./NewsItem.vue?vue&type=template&id=f08dd1a4&scoped=true"
import script from "./NewsItem.vue?vue&type=script&lang=js"
export * from "./NewsItem.vue?vue&type=script&lang=js"
import style0 from "./NewsItem.vue?vue&type=style&index=0&id=f08dd1a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08dd1a4",
  null
  
)

export default component.exports